// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2OfYs","sendOtp":"AuthorizeToLogin_sendOtp__P7Kjy"};